<template>
	<el-pagination
	  background
	  layout="prev, pager, next"
	  :total="1000" style="text-align: right">
	</el-pagination>
</template>

<script>
	export default {
	    name: "pages",
	    data(){
	        return{
	            
	        }
	    },
	    methods:{
	
	    },
	    mounted() {
	
	    }
	
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages.vue